import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { easeOutStrong } from '../../utils/motion';
type PageHeroProps = {
  eyebrow: string;
  title: string;
  lead: string;
  body?: string[];
  backLink?: {
    href: string;
    label: string;
  };
  children?: React.ReactNode;
};
export function PageHero({
  eyebrow,
  title,
  lead,
  body = [],
  backLink,
  children
}: PageHeroProps) {
  return <section className="bg-white border-b border-line pt-32 pb-20 lg:pt-44 lg:pb-24" data-id="element-1408" data-mp="r2pn2p97kt29">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: easeOutStrong
    }} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1409" data-mp="m2uvejhlzzg5">
        {backLink && <a href={backLink.href} className="inline-flex items-center gap-2 text-sm font-medium text-ink-muted hover:text-navy transition-colors duration-150 mb-8" data-id="element-1410" data-mp="dasy2u2u6za3">
            <ArrowLeft size={16} aria-hidden="true" data-id="element-1411" data-mp="1504d9w7ad4va" />
            {backLink.label}
          </a>}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16" data-id="element-1412" data-mp="2pz52jtnclki0">
          <div className="lg:col-span-5" data-id="element-1413" data-mp="2uvltswpugezb">
            <p className="text-sm font-medium text-teal mb-5" data-id="element-1414" data-mp="2g78wnwf0sq38">{eyebrow}</p>
            <h1 className="font-heading font-extrabold text-4xl sm:text-5xl lg:text-[3.25rem] text-ink-dark leading-[1.08] tracking-tight" data-id="element-1415" data-mp="2g564b5qeakvc">
              {title}
            </h1>
          </div>
          <div className="lg:col-span-7 lg:pt-10" data-id="element-1416" data-mp="2759e2zocxdy6">
            <p className="text-2xl text-ink-dark leading-relaxed" data-id="element-1417" data-mp="2c5xc45b06v1w">{lead}</p>
            {body.length > 0 && <div className="mt-6 space-y-5" data-id="element-1418" data-mp="1x9g15f6q7ifv">
                {body.map(paragraph => <p key={paragraph} className="text-lg text-ink-muted leading-relaxed" data-id="element-1419" data-mp="226odgz570s97">
                    {paragraph}
                  </p>)}
              </div>}
            {children}
          </div>
        </div>
      </motion.div>
    </section>;
}